/**
 * Where the client gets the seed it draws.
 *
 * A level costs about forty bytes on the wire because it *is* a seed: the server
 * will send `{seed, depth, biome}` and every client regenerates a byte-identical
 * cave. Until there is a server, the URL stands in — `?seed=42` — which keeps
 * the client honest about never inventing a map of its own.
 *
 * A query string is user input, so a malformed seed falls back to the default
 * rather than throwing. An unparameterised load always shows the same cave.
 */

/** The cave you get with no `?seed=`. Arbitrary, but fixed — determinism starts here. */
export const DEFAULT_SEED = 20260812;

const SEED_PARAMETER = 'seed';

export const parseSeed = (search: string): number => {
  const raw = new URLSearchParams(search).get(SEED_PARAMETER);
  if (raw === null || raw.trim() === '') return DEFAULT_SEED;

  const seed = Number(raw);

  // Integer, not merely finite: `restoreRng` truncates to an int32, and a seed
  // that silently becomes a different seed is worse than one that is ignored.
  return Number.isInteger(seed) ? seed : DEFAULT_SEED;
};
